// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DIAqIg_k8UOWZjjKsbMo{flex-grow:1;margin-left:16px;display:flex;position:relative}.NHK73HSmftwV9qcaX1vg{justify-content:space-between;align-items:center;gap:12px;display:flex}.yDexnZibccs0sqKwYs_t{align-items:center;gap:12px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapTable": `DIAqIg_k8UOWZjjKsbMo`,
	"contactColumn": `NHK73HSmftwV9qcaX1vg`,
	"contactColumnName": `yDexnZibccs0sqKwYs_t`
};
export default ___CSS_LOADER_EXPORT___;
